import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { CURRENCIES } from "@/lib/currencies";

interface CurrencySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  /** When true, option values are stored/emitted as lowercase (e.g. "usd") for backward compat */
  lowercase?: boolean;
  triggerClassName?: string;
  placeholder?: string;
  "data-testid"?: string;
}

export function CurrencySelect({
  value,
  onValueChange,
  disabled,
  lowercase = false,
  triggerClassName,
  placeholder = "Select currency",
  "data-testid": testId,
}: CurrencySelectProps) {
  const displayCode = value ? value.toUpperCase() : null;

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className={triggerClassName} data-testid={testId}>
        {displayCode ? (
          <span>{displayCode}</span>
        ) : (
          <span className="text-muted-foreground">{placeholder}</span>
        )}
      </SelectTrigger>
      <SelectContent>
        {CURRENCIES.map((c) => (
          <SelectItem key={c.code} value={lowercase ? c.code.toLowerCase() : c.code}>
            {c.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
